const isProduction = true;
const middleware_url = isProduction
  ? "https://sysflex--production-app--fqk5qfx7kgsv.code.run"
  : "https://tight-mosquito-cheaply.ngrok-free.app";
const imagePlaceholder = "https://via.placeholder.com/150x150";

let favoriteP12 = "";

/**
 * @description fetches configurator items (with first batch of rules) - caches it and redirects to form page
 */
function buildConfiguratorFormItems(event) {
  $.ajax({
    url: middleware_url + "/configurator-items",
    type: "POST",
    crossDomain: true,
    data: event.data.body,
    dataType: "json",
    encode: true,
    cache: false,
    success: function (data) {
      localStorage.setItem("bom_csv_items", JSON.stringify(data));
      document.location.href = "/pages/configurator-form";
    },
    error: function (xhr) {
      console.log("error", xhr.statusText);
      $("#error-message").show();
    },
  });
}

function disableFinish() {
  $(`.select2__colour.select2__product`).on("select2:select", function (e) {
    const currentlySelected = $(this).find(":selected")?.[0];
    const currentValue = currentlySelected?.innerHTML;
    const productID = e?.target?.id?.replace("colour_product-", "");
    const finishDropdown = $(`#finish_product-${productID}`);

    // If the selected color is Geanodiseerd - disabled finish
    if (currentValue === "Geanodiseerd") {
      // Get the finish element and set it as empty
      finishDropdown.val("");
      finishDropdown
        .prop("selectedIndex", -1)
        .trigger("change")
        .trigger("select2:select");

      finishDropdown.attr("disabled", true);
    } else {
      finishDropdown.attr("disabled", null);
      if (finishDropdown?.val()?.length > 0 === false) {
        finishDropdown
          .prop("selectedIndex", 0)
          .trigger("change")
          .trigger("select2:select");
      }
    }
  });
}

/**
 * @description update the P12 color based on the A 12 selected color
 */
const updateP12Color = () => {
  // Before all transofmrations Update the P 12 products to match the right A 12 Colors
  let a12Color = $(".select2[name='colour_product-A 12 Brut 55']");
  let p12Color = $(".select2[name='colour_product-P 12 Brut 30']");
  if (p12Color != null) {
    let selectedColor = "";
    // Listen to all the changes
    for (let eventName of [
      "change.select2",
      "select2:select",
      "select2:clear",
    ]) {
      a12Color.on(eventName, (e) => {
        selectedColor = $(e?.target)?.find(":selected")?.[0]?.value;

        let p12ColorMatch = $("input[name='match-P 12 Brut 30']");

        // If the select color is there
        if (selectedColor?.length > 0) {
          // Find the right matching color
          switch (selectedColor) {
            case "9001":
            case "9003":
            case "9010":
            case "9016":
              favoriteP12 = "Wit";
              break;

            case "9002":
            case "7035":
            case "7044":
              favoriteP12 = "Grijs";
              break;

            default:
              favoriteP12 = "Zwart";
              break;
          }
        }
        // Otherwise: Clear the favorite data
        else {
          favoriteP12 = "";
        }
        p12ColorMatch.val(favoriteP12);
      });
    }
  }
};

/**
 * @description updates all the form products to the value of the master select
 */
function updateAllProducts() {
  $("#update-products").on("click", function (e) {
    e.preventDefault();
    var master_finish = $(".select2-master__finish").val();
    var master_colour = $(".select2-master__colour").val();
    var master_colour_glass = $(".select2-master__colour-glass").val();
    var master_colour_solid = $(".select2-master__colour-solid").val();

    $(`.select2__colour.select2__product`)
      .has(`option[value="${master_colour}"]`)
      .val(master_colour)
      .trigger("change");

    $(`.select2__finish.select2__product`)
      .has(`option[value="${master_finish}"]`)
      .val(master_finish)
      .trigger("change");

    if (master_colour_glass) {
      $(`.select2__colour.select2__product[frame_type="Glazen deur"]`)
        .has(`option[value="${master_colour}"]`)
        .val(master_colour_glass)
        .trigger("change");
    }

    if (master_colour_solid) {
      $(
        `.select2__colour.select2__product[frame_type="Dichte deur"], .select2__colour.select2__product[frame_type="Kader"]`
      )
        .has(`option[value="${master_colour}"]`)
        .val(master_colour_solid)
        .trigger("change");
    }
  });
}

/**
 * @description Filters non-unique values from array
 */
function filterNonUnique(data = []) {
  return data.filter((value, index, self) => self.indexOf(value) === index);
}

/**
 * @description gets the frame options based on height
 */
function getOptionsByHeight(frame_height, options, frame_type) {
  let heightInt = Number(frame_height);
  const chosenFrame = options?.[0].find((e) => e?.name === frame_type);
  let heightOptions = chosenFrame?.nested.map((e) =>
    e.replace(/([a-zA-Z])|(\s)/g, "")
  ); // Remove everything but numbers and characters

  heightOptions = heightOptions.map((e) => {
    return e?.includes("-")
      ? e
          ?.split("-")
          .map((e) => Number(e))
          ?.flat()
      : [Number(e)];
  });

  const heightOptionIndex = heightOptions.findIndex((e) => {
    let from = e?.length === 1 ? 0 : e?.[0];
    let to = e?.length === 1 ? e?.[0] : e?.[1];
    return from <= heightInt && heightInt <= to;
  });

  return chosenFrame.nested[heightOptionIndex];
}

/**
 * @description gets the frame color based on height
 */
function getColorsByFrameHeight(frame_height, options) {
  return options?.[1]?.find((option) => {
    return option?.name === frame_height;
  }).nested;
}

/**
 * @description gets the frame finish based on color
 */
function getHingesByFrameColor(selectedColor, options) {
  return options?.[2]?.find((option) => {
    let colorToFind = selectedColor !== "9010" ? "Standaard RAL" : "9010";
    return colorToFind === option.name;
  })?.nested;
}

/**
 * @description gets the frame handle based on finish
 */
function getTypeByFrameFinish(selectedFinish, options) {
  return options?.[3]?.find((option) => {
    return option?.name === selectedFinish;
  })?.nested;
}

/**
 * @description gets the frame handle based on door type
 */
function getLockByDoorType(selectedDoorType, options) {
  return options?.[4]?.find((option) => {
    return option?.name.toLowerCase() === selectedDoorType.toLowerCase();
  })?.nested;
}

/**
 * @description Clear error state from dropdowns
 */
const handleErrorTouched = () => {
  for (let eventName of [
    "select2:open",
    "change.select2",
    "select2:select",
    "select2:clear",
  ]) {
    $(".select2").on(eventName, (e) => {
      // Get the select element name parent container
      const errorElement = $(e?.target).parent().find(".has-error");
      $(errorElement)?.toggleClass("has-error", false);
    });
  }
};

/**
 * @description gets the frame handle based on door type
 */
function getHandleByFrameLock(selectedHandle, options) {
  return options?.[5]?.find((option) => {
    return option?.name === selectedHandle;
  })?.nested;
}

/**
 * @description update dropdown value
 */

function updateDropDownVal(select, options, current) {
  select.empty().append(options);
  let selectedValue = options?.some((e) => e?.value === current);
  if (selectedValue) {
    select.val(current);
  } else {
    select.val(options?.[0]?.value);
  }
}

/**
 * @description applies the frame cascading changes
 */
function updateFrameSelection(
  frameData,
  options,
  index,
  favorites,
  allFinishes
) {
  const { frame_type } = frameData;
  const colorSelect = $(`[name="${`colour_product-${frame_type}-${index}`}"]`);
  const finishSelect = $(`[name="${`finish_product-${frame_type}-${index}`}"]`);
  const lockSelect = $(`[name="${`lock_product-${frame_type}-${index}`}"]`);
  const handleSelect = $(`[name="${`handle_product-${frame_type}-${index}`}"]`);
  const hingeSelect = $(`[name="${`hinge_product-${frame_type}-${index}"`}]`);

  const color = colorSelect.find(":selected")?.[0]?.value;
  const finish = finishSelect.find(":selected")?.[0]?.value;
  const lock = lockSelect.find(":selected")?.[0]?.value;
  const handle = handleSelect.find(":selected")?.[0]?.value;
  const hinge = hingeSelect.find(":selected")?.[0]?.value;

  const {
    finishOptions,
    colorOptions,
    hingeOptions,
    handleOptions,
    lockOptions,
  } = generateFrameOptions(
    frameData,
    options,
    { color, finish, hinge, handle, lock },
    favorites,
    allFinishes
  );

  for (let entry of [
    { options: finishOptions, element: finishSelect },
    { options: lockOptions, element: lockSelect },
    { options: handleOptions, element: handleSelect },
    { options: hingeOptions, element: hingeSelect },
  ]) {
    if (entry.options?.length > 1 === false) {
      $($(entry.element).parent()).toggleClass("hidden", true);
    } else {
      $($(entry.element).parent()).toggleClass("hidden", false);
    }
  }
  updateDropDownVal(colorSelect, colorOptions, color);
  updateDropDownVal(finishSelect, finishOptions, finish);
  updateDropDownVal(lockSelect, lockOptions, lock);
  updateDropDownVal(handleSelect, handleOptions, handle);
  updateDropDownVal(hingeSelect, hingeOptions, hinge);

  const favMatch = findFavoriteRow(favorites);

  // Update the rows
  for (let [panelType, color] of Object.entries(favMatch)) {
    // Update the best match
    $(`input[name="match-${panelType}"]`).val(color);
  }
}

/**
 * @description updates favorites input field when the master color changes
 */
function updateFavoriteMatch(favoriteMatrix) {
  $(".select2.select2-master__colour").on("select2:select", (e) => {
    // Find the match for all panels
    const favMatch = findFavoriteRow(favoriteMatrix);

    // Update the rows
    for (let [panelType, color] of Object.entries(favMatch)) {
      // Update the best match
      $(`input[name^="match-${panelType}"]`).val(color);
    }
  });
}

/**
 * @description returns the nested options tree based on current selections
 */
function generateFrameOptions(
  frameData,
  rawOptions,
  selections,
  colors,
  finishes
) {
  let options = [...rawOptions];

  // 1. Get the frame options based on its height
  const { frame_height, frame_type, door_type } = frameData;
  const heightOption = getOptionsByHeight(frame_height, options, frame_type);

  // 2. Get the colors by height
  let colorOptions = getColorsByFrameHeight(heightOption, options);
  // Populate the "Standaard RAL" with all options
  const standardColor = colorOptions.find((e) => e === "Standaard RAL");
  for (let color of colors) {
    if (color[0] === "9010") {
      continue;
    }
    if (standardColor) {
      colorOptions = [...colorOptions, color[0]];
    }
  }

  // Filter out the standard ral
  colorOptions = colorOptions.filter((e) => e !== "Standaard RAL");

  // 3. Get the hinge based on color
  const hingeOptions = getHingesByFrameColor(
    selections?.color ?? colorOptions?.[0],
    options
  );

  // 4. Get the door type
  let doorType = "";
  switch (door_type.toLowerCase()) {
    case "dichte":
    case "dichte deur":
      doorType = "Dichte deur";
      break;

    case "glazen deur":
    case "glasdeur":
    case "glas":
      doorType = "Glasdeur";
      break;

    case "kader":
    case "kader deur":
      doorType = "Kaderdeur";
      break;
  }

  // 5. Get the lock options
  const lockOptions = getLockByDoorType(doorType, options) ?? [];

  // 6. Get the hinges based on selected handle
  const handleOptions =
    getHandleByFrameLock(selections?.lock ?? lockOptions?.[0], options) ?? [];

  return Object.fromEntries(
    Object.entries({
      finishOptions: [undefined, ...finishes],
      colorOptions: [undefined, ...colorOptions],
      lockOptions: [undefined, ...lockOptions],
      hingeOptions: [undefined, ...hingeOptions],
      handleOptions: [undefined, ...handleOptions],
    }).map(([key, value]) => {
      return [
        key,
        value?.map((e) => {
          const option = new Option(e, e, false, false);
          if (key === "colorOptions") {
            const matchingHex = colors.find((entry) => {
              return entry?.[0] === e;
            })?.[5];
            if (matchingHex != null) {
              option.setAttribute("data-color-text", matchingHex);
              option.setAttribute("data-color-hex", matchingHex);
            }
          }
          return option;
        }) ?? value,
      ];
    })
  );
}

/**
 * @description removes the cart attributes one by one
 */
function clearCartAttributes() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (resp) {
      var nullHash = {};
      for ([key, value] of Object.entries(resp.attributes)) {
        nullHash[key] = null;
      }
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { attributes: nullHash },
        dataType: "json",
      });
    },
  });
}

/**
 * @description clears the cart
 */
function clearCart() {
  return $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    data: "",
    dataType: "json",
    success: function () {
      // clearCartAttributes();
    },
    error: function (XMLHttpRequest, textStatus) {
      /* error code */
    },
  });
}

/**
 * @description adds event handler to the configurator form submission
 */

function handleConfiguratorSubmission() {
  // this is the id of the form
  $(".product-solo--form").submit(function (e) {
    e.preventDefault(); // avoid to execute the actual submit of the form.
    var form = $(this);
    // Disable the submission button
    var submissionButton = $("#update-price");
    try {
      submissionButton.prop("disabled", true);
      submissionButton.toggleClass("button--loading", true);

      // Check if there are dropdowns with no values
      const allDropdowns = [...$(".select2-selection")]?.filter((elm) => {
        return (
          $(elm)
            .find(".select2-selection__rendered")?.[0]
            ?.getAttribute("title")
            ?.toLowerCase()
            ?.includes("kies een") && $(elm).parents(".d-none").length === 0
        );
      });

      if (allDropdowns?.length > 0) {
        // Show the error fields
        allDropdowns.forEach((e) => {
          return $(e).toggleClass("has-error", true);
        });

        submissionButton.prop("disabled", false);
        submissionButton.toggleClass("button--loading", false);
        const yOffset = -150;
        // Get the first instance
        const y =
          allDropdowns?.[0]?.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
        return;
      }

      const subFormValues =
        $("form.product-row")
          ?.serializeArray()
          .filter((entry) => {
            return entry.value !== "undefined" && entry.name !== entry.value;
          }) ?? [];

      const mainFormValue = form.serializeArray().filter((entry) => {
        return entry.value !== "undefined" && entry.name !== entry.value;
      });

      const formValues = [...mainFormValue, ...subFormValues];

      // Clear the cart first
      clearCart();

      const json = localStorage.getItem("bom_csv_items");
      const obj = JSON.parse(json);
      const bomString = obj?.bom;

      let bom = null;
      if (bomString != null) {
        bom = JSON.parse(bomString);
      }

      const bomID = bom?.bom?.id;

      $.ajax({
        url: `${middleware_url}/create-checkout`,
        type: "POST",
        crossDomain: true,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(formValues),
        success: function (res) {
          const mainBom = localStorage.getItem("main_bom");
          let extraLinks = {};
          if (mainBom != null) {
            const mainBomObject = JSON.parse(mainBom);
            extraLinks = mainBomObject?.bom;
            delete extraLinks.bill_of_materials;
          }
          addCartAttributes(extraLinks);
          let hplAttribute = "";
          const sortedList = res.data
            .map((e) => {
              // Fitler out HPL
              if (e?.["match-HPL"] != null) {
                hplAttribute = `${e?.sku?.replace(/-/g, " ")}`;
              }
              return e;
            })
            .map((e) => {
              if (e?.door_type == null) {
                return e;
              } else if (e?.door_type?.toLowerCase() === "dichte deur") {
                return { ...e, HPL: hplAttribute };
              }
              return e;
            })
            .sort((a, b) => {
              // Sort the frames to be on top
              if (a.door_type != null && b.door_type == null) {
                return -1;
              } else if (b.door_type != null && a.door_type == null) {
                return 1;
              }
              // Otherwise, return the data in order
              return a.sku.localeCompare(b.sku);
            })
            .reverse();

          $.each(sortedList, function (k, v) {
            if (v != undefined && v.hasOwnProperty("link")) {
              push_to_queue(v.id, v.qty, {
                link: v.link,
              });
            } else if (v != null) {
              push_to_queue(v.id, v.qty, {
                "BOM ID": bomID,
                HPL: v?.HPL,
                Kleur: v.color,
                Afwerking: v.finish,
                Draairichting: v?.direction,
                Hoogte: v?.height,
                Breedte: v?.width,
                Handle: v?.handle,
                Hinge: v?.hinge,
                Slot: v?.lock,
              });
            }
          });
          Shopify.moveAlong();
        },
        error: function (xhr) {
          submissionButton.prop("disabled", false);
          submissionButton.toggleClass("button--loading", false);

          console.log("error", xhr);
        },
      });
    } catch (ex) {
      submissionButton.prop("disabled", false);
      submissionButton.toggleClass("button--loading", false);
    }
  });
}

/**
 * @description sets the initial strcuture for the form before the options are loaded
 */
function buildEmptyProductForm() {
  $(".select2.select2-master__colour").select2({
    placeholder: "Kies een kleur...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
    templateResult: function (container) {
      let hexColor =
        container?.element?.getAttribute("data-color-text") ??
        container?.element?.getAttribute("data-color-hex");
      if (container?._resultId?.includes("P12Brut30")) {
        if (container?.text === favoriteP12) {
          return `<div data-color-text="(Aanbeloven)" data-color-hex="(Aanbeloven)">${container.text}<span class="color-block"  data-color-text="(Aanbeloven)"></span></div>`;
        }
        return `<div>${container.text}</div>`;
      }
      if (hexColor != null) {
        return `<div data-color-hex=${hexColor}>${container.text}<span class="color-block"  data-color-hex=${hexColor} style="color:${hexColor}; border: 1px solid black;"></span></div>`;
      }
      return `<div>${container.text}</div>`;
    },
    templateSelection: function (container) {
      const hexColor =
        container?.element?.getAttribute("data-color-hex") ??
        container?.element?.getAttribute("data-color-text");
      if (hexColor?.length > 0) {
        return `<div data-color-hex=${hexColor}><span data-color-hex=${hexColor} class="color-block" style="color:${hexColor}; border: 1px solid black;"></span>${container.text}</div>`;
      }
      return `<div><span class="color-block"></span>${container.text}</div>`;
    },
  });

  $(".select2.select2-master__finish").select2({
    placeholder: "Kies een afwerking...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
  });

  $(".select2.select2-master__colour-solid").select2({
    placeholder: "Kies een kleur...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
    templateResult: function (container) {
      let hexColor =
        container?.element?.getAttribute("data-color-text") ??
        container?.element?.getAttribute("data-color-hex");
      if (container?._resultId?.includes("P12Brut30")) {
        if (container?.text === favoriteP12) {
          return `<div data-color-text="(Aanbeloven)" data-color-hex="(Aanbeloven)">${container.text}<span class="color-block"  data-color-text="(Aanbeloven)"></span></div>`;
        }
        return `<div>${container.text}</div>`;
      }
      if (hexColor != null) {
        return `<div data-color-hex=${hexColor}>${container.text}<span class="color-block"  data-color-hex=${hexColor} style="color:${hexColor}; border: 1px solid black;"></span></div>`;
      }
      return `<div>${container.text}</div>`;
    },
    templateSelection: function (container) {
      const hexColor =
        container?.element?.getAttribute("data-color-hex") ??
        container?.element?.getAttribute("data-color-text");
      if (hexColor?.length > 0) {
        return `<div data-color-hex=${hexColor}><span data-color-hex=${hexColor} class="color-block" style="color:${hexColor}; border: 1px solid black;"></span>${container.text}</div>`;
      }
      return `<div><span class="color-block"></span>${container.text}</div>`;
    },
  });

  $(".select2.select2-master__colour-glass").select2({
    placeholder: "Kies een kleur...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
    templateResult: function (container) {
      let hexColor =
        container?.element?.getAttribute("data-color-text") ??
        container?.element?.getAttribute("data-color-hex");
      if (container?._resultId?.includes("P12Brut30")) {
        if (container?.text === favoriteP12) {
          return `<div data-color-text="(Aanbeloven)" data-color-hex="(Aanbeloven)">${container.text}<span class="color-block"  data-color-text="(Aanbeloven)"></span></div>`;
        }
        return `<div>${container.text}</div>`;
      }
      if (hexColor != null) {
        return `<div data-color-hex=${hexColor}>${container.text}<span class="color-block"  data-color-hex=${hexColor} style="color:${hexColor}; border: 1px solid black;"></span></div>`;
      }
      return `<div>${container.text}</div>`;
    },
    templateSelection: function (container) {
      const hexColor =
        container?.element?.getAttribute("data-color-hex") ??
        container?.element?.getAttribute("data-color-text");
      if (hexColor?.length > 0) {
        return `<div data-color-hex=${hexColor}><span data-color-hex=${hexColor} class="color-block" style="color:${hexColor}; border: 1px solid black;"></span>${container.text}</div>`;
      }
      return `<div><span class="color-block"></span>${container.text}</div>`;
    },
  });

  $(".select2.select2__colour").select2({
    placeholder: "Kies een kleur...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
    templateResult: function (container) {
      let hexColor =
        container?.element?.getAttribute("data-color-text") ??
        container?.element?.getAttribute("data-color-hex");
      if (container?._resultId?.includes("P12Brut30")) {
        if (container?.text === favoriteP12) {
          return `<div data-color-text="(Aanbeloven)" data-color-hex="(Aanbeloven)">${container.text}<span class="color-block"  data-color-text="(Aanbeloven)"></span></div>`;
        }
        return `<div>${container.text}</div>`;
      }
      if (hexColor != null) {
        return `<div data-color-hex=${hexColor}>${container.text}<span class="color-block"  data-color-hex=${hexColor} style="color:${hexColor}; border: 1px solid black;"></span></div>`;
      }
      return `<div>${container.text}</div>`;
    },
    templateSelection: function (container) {
      const hexColor =
        container?.element?.getAttribute("data-color-hex") ??
        container?.element?.getAttribute("data-color-text");
      if (hexColor?.length > 0) {
        return `<div data-color-hex=${hexColor}><span data-color-hex=${hexColor} class="color-block" style="color:${hexColor}; border: 1px solid black;"></span>${container.text}</div>`;
      }
      return `<div><span class="color-block"></span>${container.text}</div>`;
    },
  });

  $(".select2.select2__finish").select2({
    placeholder: "Kies een afwerking...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
  });

  $(".select2.select2__lock").select2({
    placeholder: "Kies een type slot...",
    width: "100%",
    display: {
      noResults: function () {
        return "none";
      },
    },
    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
  });

  $(".select2.select2__handle").select2({
    placeholder: "Kies een kleur deurkruk...",
    width: "100%",
    display: {
      noResults: function () {
        return "none";
      },
    },
    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
  });

  $(".select2.main_select2__colour").select2({
    placeholder: "Kies een series...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen series gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
    templateResult: function (container) {
      const hexColor = container?.element?.getAttribute("data-color-hex");

      if (hexColor != null) {
        return `<div data-color-hex=${hexColor}>${container.text}<span class="color-block"  data-color-hex=${hexColor} style="color:${hexColor}; border: 1px solid black;"></span></div>`;
      }
      return `<div>${container.text}</div>`;
    },
    templateSelection: function (container) {
      const hexColor = container?.element?.getAttribute("data-color-hex");
      return `<div><span class="color-block"></span>${container.text}</div>`;
    },
  });

  $(".select2.select2__hinge").select2({
    placeholder: "Kies een kleur scharnier...",
    width: "100%",

    language: {
      noResults: function () {
        return "Geen opties gevonden";
      },
    },
    escapeMarkup: function (markup) {
      return markup;
    },
  });
}

/**
 * @description appends the submit button to the configurator form
 */
function appendSubmitButtons(itemsLength) {
  $(".product-solo--form").append(
    $("<div>", {
      class: "row row--submit",
    }).append(
      $("<div>", {
        class: "col-12 col-md-5 col-lg-3",
      })
        .append(
          $("<button>", {
            class: "btn btn-theme--primary product-form__button",
            id: "update-price",
            text: "Prijzen bijwerken",
            type: "submit",
          })
        )
        .append(
          $("<div>", {
            class: "",
            id: "added-count",
            text: "Producten toegevoegd: ",
          })
            .append(
              $("<span>", {
                class: "",
                id: "current-count",
                text: "0",
              })
            )
            .append(
              $("<span>", {
                class: "",
                id: "total-count",
                text: "/" + itemsLength,
              })
            )
        )
    )
  );

  $(".product-solo--form").append(
    $("<div>", {
      class: "row row--submit",
    }).append(
      $("<div>", {
        class: "col-12",
      }).append(
        $("<input>", {
          class: "btn btn-theme--primary product-form__button",
          id: "to-cart",
          style: "display: none;",
          value: "Naar afrekenen",
          text: "Naar afrekenen",
          type: "submit",
        })
      )
    )
  );
}

/**
 * @setup the options for the form products
 */
function setupOptions(objectEntry, favoritesMatrix) {
  for (const prop in objectEntry) {
    switch (prop) {
      case "color":
        if (objectEntry["color"]) {
          const colours = shapeItemFinishColor([objectEntry], "color");

          // Add empty option on top to display placeholder
          for (let selector of [
            "select.product-colour",
            "select.product-finish",
            "select.product-handle",
            "select.product-hinge",
            "select.main-color-select",
            "select.sub-colour-product",
          ]) {
            $(
              selector + objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "")
            ).append(
              $("<option>", {
                value: null,
                text: null,
              })
            );
          }

          for (let c = 0; c < colours.length; c++) {
            $(
              "select.product-colour" +
                objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "")
            ).append(
              $("<option>", {
                value: colours[c],
                text: colours[c],
                "data-color-text":
                  favoritesMatrix.find((fav) => fav[0] === colours[c])?.[5] ??
                  "", // Get the matching hex
              })
            );
          }
        }
        break;
      case "finish":
        if (objectEntry["finish"]) {
          const finishes = shapeItemFinishColor([objectEntry], "finish");
          for (let f = 0; f < finishes.length; f++) {
            $(
              "select.product-finish" +
                objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "")
            ).append(
              $("<option>", {
                value: finishes[f],
                text: finishes[f],
              })
            );
          }
        }
        break;

      case "handles":
        handlesArray = [];
        if (objectEntry["type"] == "frame") {
          let handles = objectEntry["handles"];
          for (let h = 0; h < handles.length; h++) {
            // Push to master array
            handlesArray.push(handles[h]);

            $(
              "select.product-handle" +
                objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "")
            ).append(
              $("<option>", {
                value: handles[h],
                text: handles[h],
              })
            );
          }
        }
        break;

      case "hinges":
        hingesArray = [];
        if (objectEntry["type"] == "frame") {
          let hinges = objectEntry["hinges"];
          for (let h = 0; h < hinges.length; h++) {
            // Push to master array
            hingesArray.push(hinges[h]);

            $(
              "select.product-hinge" +
                objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "")
            ).append(
              $("<option>", {
                value: hinges[h],
                text: hinges[h],
              })
            );
          }
        }
        break;
    }
  }
}

/**
 * @description setup the items with regular color/finish
 */
function setupItems(objectEntry, favoritesMatrix, i) {
  $(".product-solo--form")
    .append(
      $("<div>", {
        class: "row label_row",
      })
    )
    .append(
      $("<div>", {
        class:
          "row mb-5 product-row justify-content-between product-" +
          objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "") +
          ` ${
            objectEntry?.type === "item" &&
            objectEntry?.color?.length > 1 === false &&
            objectEntry?.finish?.length > 1 === false
              ? "d-none"
              : ""
          }`,
      })
        .append(
          $("<div>", {
            class:
              "col-12 col-sm-3 product_image d-flex justify-content-between",
          }).append(
            $("<img>", {
              class: "image-contain",
              alt: objectEntry?.sku,
              src: objectEntry?.image
                ? objectEntry?.image?.includes("width")
                  ? objectEntry.image
                  : objectEntry + "&width=150"
                : imagePlaceholder,
            })
          )
        )
        .append(
          $("<div>", {
            class: "col-12 col-sm-8 product_data",
          })
            .append(
              $("<div>", {
                class: "col-12 product_meta",
              })
                .append(
                  $(
                    "<div class='row m-1'><input readOnly='readOnly' name='sku-" +
                      objectEntry["sku"] +
                      "' value='" +
                      objectEntry["sku"] +
                      "'></div>"
                  )
                )
                .append(
                  $(
                    `<div class='row m-1 ${
                      objectEntry?.sku === "P 12 Brut 30" ? "" : "mb-3"
                    }'><strong>Aantal: </strong> <input readOnly='readOnly' name='qty-` +
                      objectEntry["sku"] +
                      "' value='" +
                      objectEntry["qty"] +
                      "'></div>"
                  )
                )
                .append(
                  $(
                    `<div class='row m-1 mb-3 ${
                      objectEntry?.sku === "P 12 Brut 30" ? "" : "d-none"
                    }'><strong>Beste Match: </strong> <input readOnly='readOnly' name='match-` +
                      objectEntry["sku"] +
                      `' value=''></div>`
                  )
                )
            )
            .append(
              $("<div>", {
                class: `col-12 mx-0 ${
                  objectEntry?.color?.length > 1 === false ? "d-none" : ""
                }`,
              }).append(
                $("<select>", {
                  class:
                    "select2 select2__colour select2__product product-colour" +
                    objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "") +
                    " " +
                    i,
                  name: "colour_product-" + objectEntry["sku"],
                  id:
                    "colour_product-" +
                    objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "") +
                    i,
                })
              ) // ending select=colour
            ) // ending form control

            .append(
              $("<div>", {
                class: `col-12 mx-0 ${
                  objectEntry?.finish?.length > 1 === false ? "d-none" : ""
                }`,
              }).append(
                $("<select>", {
                  class:
                    "select2 select2__finish select2__product  product-finish" +
                    objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "") +
                    " " +
                    i,
                  name: "finish_product-" + objectEntry["sku"],
                  id:
                    "finish_product-" +
                    objectEntry["sku"].replace(/\s+|[^A-Za-z0-9]/g, "") +
                    i,
                })
              )
            )
        )
    );

  setupOptions(objectEntry, favoritesMatrix);
}

/**
 * @description initiate the panels form options (with colors)
 */
function setupPanels(panel, index) {
  // Loop over the panels list
  const { sku, qty, colors, counter = 0, type = "" } = panel;
  const identifier = sku.replace(/\s+|[^A-Za-z0-9]/g, "");

  let appendTo = $(".product-solo--form");
  const isHPL = type.toLowerCase() === "hpl";
  // Check if it's HPL - append it under the dichte deur
  if (isHPL) {
    appendTo = $($("input[value='Dichte deur']")?.[counter]).parent("div");
  }

  for (let entry of appendTo) {
    let element = $(entry);
    let modifiedColors = colors;
    if (isHPL) {
      // filter out unwanted colours temporarily
      const acceptedSubColors = [
        "ME006",
        "ME007",
        "MU732",
        "MU963",
        "MU999",
        "MF501",
        "MH1277",
        "MH1334",
        "MH3090",
        "MH3734",
        "MH1199",
      ];
      modifiedColors = modifiedColors
        .filter(({ subColours }) => {
          return acceptedSubColors.some((accepted) =>
            subColours.some((sub) => sub.name === accepted)
          );
        })
        .map(({ subColours, ...rest }) => {
          return {
            ...rest,
            subColours: subColours.filter((e) =>
              acceptedSubColors.some((accepted) => accepted === e.name)
            ),
          };
        });
      if (element.attr("initialized") != null) {
        return;
      }
    }
    element.append(
      $(isHPL ? "<form>" : "<div>", {
        class:
          `row product-row justify-content-between ${
            isHPL ? "" : "align-items-end"
          } mb-5 product-` + identifier,
      })
        .append(
          $("<div>", {
            class: ` col-12 col-sm-3 product_image d-flex ${
              isHPL ? "" : "justify-content-center"
            } `,
          }).append(
            $("<img>", {
              alt: sku,
              src: panel?.image
                ? panel?.image.includes("width")
                  ? panel?.image
                  : panel.image + "&width=150"
                : imagePlaceholder,
            })
          )
        )
        .append(
          $("<div>", {
            class: "col-12 col-sm-8 product_meta",
          })
            .append(
              $(
                "<div class='row m-1'><input readOnly='readOnly' name='sku-" +
                  identifier +
                  "' value='" +
                  sku +
                  "'></div>"
              )
            )
            .append(
              isHPL
                ? $(
                    "<div class='row m-1'><strong data-value=" +
                      panel.width +
                      ">Breedte: </strong> <input readOnly='readOnly' name='width-" +
                      identifier +
                      "' value='" +
                      panel.width +
                      "'></div>",
                    {
                      text: panel.width
                        ? "Breedte: " + panel.width + "mm"
                        : "Breedte: onbekend",
                      class: "p-0 m-0",
                    }
                  )
                : ""
            )
            .append(
              isHPL
                ? $(
                    "<div class='row m-1'><strong data-value=" +
                      panel.height +
                      ">Hoogte: </strong> <input readOnly='readOnly' name='height-" +
                      identifier +
                      "' value='" +
                      panel.height +
                      "'></div>",
                    {
                      text: panel.height
                        ? "Lengte: " + panel.height + "mm"
                        : "Lengte: onbekend",
                      class: "p-0 m-0",
                    }
                  )
                : ""
            )
            .append(
              $(
                "<div class='row m-1 mb-1'><strong>Aantal: </strong> <input data-original-qty='" +
                  qty +
                  "'  readOnly='readOnly' name='qty-" +
                  identifier +
                  "' value='" +
                  qty +
                  "'></div>"
              )
            )
            .append(
              $(
                "<div class='row m-1 mb-3'><strong>Beste Match: </strong> <input readOnly='readOnly' name='match-" +
                  identifier +
                  "' value=''></div>"
              )
            )
            .append(
              $("<div>", {
                class: "row align-items-end",
                name: "product-color-group" + identifier + counter,
              }).append(
                $("<div>", {
                  class: "col-12",
                }).append(
                  $("<select>", {
                    class: `select2 main_select2__colour main-color-select`,
                    name: "main_colour_product-" + identifier,
                    "data-counter": counter,
                    id:
                      "main_colour_product-" +
                      (isHPL ? "-" + counter : "") +
                      identifier,
                  })
                    .append(
                      $("<option>", {
                        text: null,
                        value: null,
                      })
                    )
                    .append(
                      modifiedColors.map((mainColorGroup) => {
                        const { name, hex, subColours } = mainColorGroup;

                        return ` <option value="${name}" ${
                          hex != null ? `data-color-hex="${hex}"` : ""
                        } data-subcolours-array=${JSON.stringify(
                          subColours
                        )}>${name}</option>`;
                      })
                    )
                )
              )
            ) // ending form control
        )
    );
    if (isHPL) {
      $(element).attr("initialized", true);
    }
  }
}

/**
 * @description get the plate type using its SKU
 */
function getPlateTypeBySKU(sku) {
  switch (sku) {
    case "Gi 02 2750Dura":
    case "Gi 02 3000Dura":
      return "durafort";

    case "H 06 13":
    case "H 07 13":
    case "H 03 13":
      return "melamine";

    case "HPL":
      return "hpl";

    default:
      return null;
  }
}

/**
 * @description increase the amount of quantity if the color is not 00023
 */

function handleMelamineSecondaryColorChange(container) {
  // Quantity field
  const quantityInput = $(container).find('input[name^="qty-H0"]');
  $(container)
    .find('select[id^="sub_colour_product-H0"]')
    .on("select2:select", function (e, index) {
      // Get the original and current value
      const original = $(quantityInput).attr("data-original-qty");
      const selected = e?.params.data.text;
      if (selected === "00025") {
        // Get the value from LS
        quantityInput.val(original);
        return;
      }
      const rounded = Math.ceil(Number(original) / 10) * 10;
      quantityInput.val(rounded);
    });
}

/**
 * @description re-renders the sub color dropdown based on main color changing (HPL,Melamine and Durafort products)
 */
function handleMainColorChange(favoritesMatrix) {
  $(".main-color-select").on("select2:select", function (e, index) {
    const id = e?.handleObj?.guid;
    // Get the SKU of the current product
    const sku = this?.getAttribute("name")?.replace("main_colour_product-", "");
    const instanceNumber = this.getAttribute("data-counter") ?? "";
    // Get the selected option
    const selectedOption = $(this).find(":selected")?.[0];
    const subColors = selectedOption.getAttribute("data-subcolours-array");
    const favorite = selectedOption.getAttribute("data-subcolours-favorite");

    let colorsArray = [];
    try {
      colorsArray = JSON.parse(subColors);
    } catch (ex) {
      colorsArray = [];
    }

    // Get the parent container
    const productContainers = $(
      `div[name="product-color-group${sku}${instanceNumber}"]`
    );

    for (let container of productContainers) {
      const productContainer = $(container);
      // Get the children
      let childrenRows = productContainer?.children()?.length;

      // remove last child
      while (childrenRows > 1) {
        productContainer.children().last().remove();
        // Re-initiate
        childrenRows = productContainer?.children()?.length;
      }
      if (colorsArray?.length > 0) {
        // Append a select2 elemnt to it
        const result = productContainer.append(
          $("<div>", {
            class: "col-12",
          }).append(
            $("<select>", {
              class:
                "select2 sub_select2__colour sub-color-select sub-colour-product",
              name: "sub_colour_product-" + sku + instanceNumber,
              id: "sub_colour_product-" + sku + instanceNumber,
            })
              .append(
                $("<option>", {
                  text: null,
                  value: null,
                })
              )
              .append(
                colorsArray
                  .sort((a, b) => {
                    const favoriteRow = findFavoriteRow(favoritesMatrix);
                    return a.name === favoriteRow[sku] ? -1 : 0;
                  })
                  .map((subColor) => {
                    const { name, hex } = subColor;

                    return ` <option ${
                      favorite === name ? `class="${favorite}"` : ""
                    } value="${name}" ${
                      hex != null ? `data-color-hex="${hex}"` : null
                    }>${name}</option>`;
                  })
              )
          )
        );

        result.find("select").select2({
          placeholder: "Kies een kleur...",
          width: "100%",

          language: {
            noResults: function () {
              return "Geen kleuren gevonden";
            },
          },
          sorter: (data) => {
            return data.sort((a, b) => {
              const favoriteRow = findFavoriteRow(favoritesMatrix);
              return a.text === favoriteRow[sku] ? -1 : 0;
            });
          },
          templateResult: function (container) {
            const hexColor = container?.element?.getAttribute("data-color-hex");
            if (hexColor != null) {
              return `<div data-color-hex=${hexColor}>${container.text}<span class="color-block"  data-color-hex=${hexColor} style="color:${hexColor}; border: 1px solid black;"></span></div>`;
            }
            return `<div>${container.text}</div>`;
          },
          templateSelection: function (container) {
            const hexColor = container?.element?.getAttribute("data-color-hex");
            return `<div data-color-hex=${hexColor}><span data-color-hex=${hexColor} class="color-block" style="color:${hexColor}; border: 1px solid black;"></span>${container.text}</div>`;
          },
          escapeMarkup: function (markup) {
            return markup;
          },
        });
        handleMelamineSecondaryColorChange(
          result.parents(".col-12.col-sm-8.product_meta")
        );
      }
      updateFavorites(favoritesMatrix);
    }
  });

  // Trigger the change on init render
  // $(".main-color-select")
  //   .prop("selectedIndex", 0)
  //   .trigger("change")
  //   .trigger("select2:select");
}

function setupGlassPanels(glassPanels) {
  // Loop through the frames
  for (let i in glassPanels) {
    const glassPanel = glassPanels[i];
    const identifier = `${glassPanel?.sku.replace(/\s+|[^A-Za-z0-9]/g, "")}_(${
      glassPanel?.width
    }x${glassPanel?.height})`;

    $(".product-solo--form").append(
      $("<div>", {
        class: "row product-row d-none product-" + identifier,
      }).append(
        $("<div>", {
          class: "col-12 product_meta",
        })
          .append(
            $(
              "<div class='row m-1'><input readOnly='readOnly' name='sku-" +
                identifier +
                "' value='" +
                identifier +
                "'></div>"
            )
          )
          .append(
            $(
              "<div class='row m-1'><strong>Aantal: </strong> <input readOnly='readOnly' name='qty-" +
                identifier +
                "' value='" +
                glassPanel?.qty +
                "'></div>"
            )
          )
          .append(
            $(
              "<div class='row m-1'><strong data-value=" +
                glassPanel.width +
                ">Breedte: </strong> <input readOnly='readOnly' name='width-" +
                identifier +
                "' value='" +
                glassPanel.width +
                "'></div>",
              {
                text: glassPanel.width
                  ? "Breedte: " + glassPanel.width + "mm"
                  : "Breedte: onbekend",
                class: "p-0 m-0",
              }
            )
          )
          .append(
            $(
              "<div class='row m-1'><strong data-value=" +
                glassPanel.height +
                ">Hoogte: </strong> <input readOnly='readOnly' name='height-" +
                identifier +
                "' value='" +
                glassPanel.height +
                "'></div>",
              {
                text: glassPanel.height
                  ? "Lengte: " + glassPanel.height + "mm"
                  : "Lengte: onbekend",
                class: "p-0 m-0",
              }
            )
          )
      )
    );
  }
}

/**
 * @description initiate the frames form options
 */
function setupFrames(frames, favorites, a06Options, a78Options, allFinishes) {
  let sortedFrames = frames.sort((a, b) => {
    return a.frame_type.localeCompare(b.frame_type);
  });

  // Loop through the frames
  for (let i in sortedFrames) {
    const frame = sortedFrames[i];

    const selector = frame?.frame_type + "-" + i;

    $(".product-solo--form").append(
      $("<div>", {
        class:
          "row product-row justify-content-between mb-5 product-" +
          frame?.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
          frame.door_type +
          frame.frame_height +
          frame.frame_width +
          frame.qty +
          i,
      })
        .append(
          $("<div>", {
            class:
              "col-12 col-sm-3 product_image d-flex justify-content-between",
          }).append(
            $("<img>", {
              class: "image-contain",
              alt: selector,
              src: frame?.image?.length > 0 ? frame?.image : imagePlaceholder,
            })
          )
        )
        .append(
          $("<div>", {
            class: "col-12 col-sm-8 product_meta",
          })
            .append(
              $(
                "<div class='row m-1'><input readOnly='readOnly' name='sku-" +
                  selector +
                  "' value='" +
                  frame?.frame_type +
                  "'></div>"
              )
            )
            .append(
              $(
                "<div class='row m-1'><strong>Aantal: </strong> <input readOnly='readOnly' name='qty-" +
                  selector +
                  "' value='" +
                  frame?.qty +
                  "'></div>"
              )
            )
            .append(
              $(
                "<div class='row m-1'><strong>Draairichting: </strong> <input readOnly='readOnly' name='direction-" +
                  selector +
                  "' value='" +
                  (frame.frame_direction === "false" ? "Rechts" : "Links") +
                  "'></div>"
              )
            )

            .append(
              $(
                "<div class='row m-1'><strong data-value=" +
                  frame.frame_width +
                  ">Breedte: </strong> <input readOnly='readOnly' name='width-" +
                  selector +
                  "' value='" +
                  frame.frame_width +
                  "'></div>",
                {
                  text: frame.frame_width
                    ? "Breedte: " + frame.frame_width + "mm"
                    : "Breedte: onbekend",
                  class: "p-0 m-0",
                }
              )
            )
            .append(
              $(
                "<div class='row m-1'><strong data-value=" +
                  frame.frame_height +
                  ">Hoogte: </strong> <input readOnly='readOnly' name='height-" +
                  selector +
                  "' value='" +
                  frame.frame_height +
                  "'></div>",
                {
                  text: frame.frame_height
                    ? "Lengte: " + frame.frame_height + "mm"
                    : "Lengte: onbekend",
                  class: "p-0 m-0",
                }
              )
            )
            .append(
              $(
                "<div class='row m-1 mb-3'><strong data-value=" +
                  frame.door_type +
                  ">Deurtype: </strong> <input readOnly='readOnly' name='door_type-" +
                  selector +
                  "' value='" +
                  frame.door_type +
                  "'></div>",
                {
                  text: frame.door_type,
                  class: "p-0 m-0",
                }
              )
            )
            .append(
              $("<div class='row'></div>")
                .append(
                  $("<div>", {
                    class: "col-12",
                  }).append(
                    $("<select>", {
                      class:
                        "select2 select2__colour select2__product product-colour" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty,

                      name: "colour_product-" + selector,
                      frame_type: frame.door_type,
                      id:
                        "colour_product-" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty +
                        i,
                    })
                  ) // ending select=colour
                ) // ending form control

                .append(
                  $("<div>", {
                    class: "col-12",
                  }).append(
                    $("<select>", {
                      class:
                        "select2 select2__finish select2__product product-finish" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty,

                      name: "finish_product-" + selector,
                      id:
                        "finish_product-" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty +
                        i,
                    })
                  )
                )

                .append(
                  $("<div>", {
                    class: "col-12",
                  }).append(
                    $("<select>", {
                      class:
                        "select2 select2__hinge product-hinge" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, ""),

                      name: "hinge_product-" + selector,
                      id:
                        "hinge_product-" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty +
                        i,
                    })
                  )
                )

                .append(
                  $("<div>", {
                    class: "col-12",
                  }).append(
                    $("<select>", {
                      class:
                        "select2 select2__lock product-lock" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty,

                      name: "lock_product-" + selector,
                      id:
                        "lock_product-" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty +
                        i,
                    })
                  )
                )

                .append(
                  $("<div>", {
                    class: "col-12",
                  }).append(
                    $("<select>", {
                      class:
                        "select2 select2__handle product-handle" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, ""),

                      name: "handle_product-" + selector,
                      id:
                        "handle_product-" +
                        frame.frame_type.replace(/\s+|[^A-Za-z0-9]/g, "") +
                        frame.door_type +
                        frame.frame_height +
                        frame.frame_width +
                        frame.qty +
                        i,
                    })
                  )
                )
            )
        )
    );

    [
      "colour_product-" + frame.frame_type + "-" + i,
      "finish_product-" + frame.frame_type + "-" + i,
      "lock_product-" + frame.frame_type + "-" + i,
      "hinge_product-" + frame.frame_type + "-" + i,
      "handle_product-" + frame.frame_type + "-" + i,
    ].forEach((selector) => {
      const elm = $(`[name="${selector}"]`);
      elm.on("select2:select", (e) => {
        updateFrameSelection(
          frame,
          frame?.frame_type === "A78" ? a78Options : a06Options,
          i,
          favorites,
          allFinishes
        );
      });
      // elm.prop("selectedIndex", 0).trigger("change").trigger("select2:select");
      updateFrameSelection(
        frame,
        frame?.frame_type === "A78" ? a78Options : a06Options,
        i,
        favorites,
        allFinishes
      );
    });
  }
}

/**
 * @description finds the row from the favorites matrix, assigns it to panels
 */

function findFavoriteRow(favoriteMatrix) {
  const color = $("span[id^='select2-select2-master__colour-']").attr("title");
  // Find the color match
  const colorRow = favoriteMatrix.find((entry) => {
    return entry?.[0] === color;
  });

  return {
    HPL: colorRow?.[4],
    H0613: colorRow?.[3],
    H0713: colorRow?.[3],
    H0313: colorRow?.[3],
    Gi022750Dura: colorRow?.[2],
    Gi023000Dura: colorRow?.[2],
  };
}
/**
 * @description updates the favorite for Durafort/HPL/Melamine products
 */
async function updateFavorites(favoritesMatrix) {
  const identifiers = [
    {
      dropdownClassname: ".main-color-select",
      selectName: "main_colour_product",
      type: "series",
    },
    {
      dropdownClassname: ".sub-color-select",
      selectName: "sub_colour_product",
      type: "color",
    },
  ];
  for (let identifier of identifiers) {
    const { dropdownClassname, selectName, type } = identifier;
    $(dropdownClassname).on("select2:open", async (e) => {
      const favorites = findFavoriteRow(favoritesMatrix);

      for (let panelType of Object.keys(favorites)) {
        // Get the element's counter
        const counter = e?.target?.getAttribute("data-counter");
        let selectSeries;
        if (counter) {
          selectSeries = $(`select[data-counter="${counter}"]`);
        } else {
          selectSeries = $(`select[name^="${selectName}-${panelType}"]`);
        }

        // Get the main series array
        const optionsList = selectSeries.find(`option`);

        // Get the favorite color
        const favoriteMatch = favorites?.[panelType];
        let mainOption = null;
        if (favoriteMatch != null) {
          switch (type) {
            case "series":
              mainOption = [...optionsList].find((entry) => {
                const optionsList = JSON.parse(
                  entry.getAttribute("data-subcolours-array")
                );
                return optionsList?.some((e) => e.name === favoriteMatch);
              });

              break;

            case "color":
              mainOption = [...optionsList].find((entry) => {
                return (
                  entry?.innerHTML.toLowerCase() === favoriteMatch.toLowerCase()
                );
              });
              break;

            default:
              console.error("Type not found ", type);
              break;
          }

          // If no option was found (product isnt there) - skip
          if (mainOption == null) {
            continue;
          }

          // Find the option element
          const favoriteSelectOption = $(mainOption);

          // Find the option in select2 dropdown and highlight it
          let selectResults = $(`ul.select2-results__options`).find(
            "li.select2-results__option"
          );

          let html = selectResults?.[0]?.innerHTML;

          if (html?.includes("Searching…")) {
            await intervalCallback(100, 100, () => {
              selectResults = $(`ul.select2-results__options`).find(
                "li.select2-results__option"
              );
              html = selectResults?.[0]?.innerHTML;
              if (html?.includes("Searching…") === false) {
                return true;
              }
              return null;
            });
          }

          // Extract the html from the child element
          if (type === "color") {
            html = $(selectResults?.[0])?.find("div")?.[0]?.innerText;
          }

          const listElement = [...selectResults].find((entry) => {
            const innerHTML =
              type === "series"
                ? entry?.innerText
                : $(entry)?.find("div")?.[0]?.innerText;

            return (
              innerHTML.toLowerCase() ===
              favoriteSelectOption?.[0].innerText?.toLowerCase()
            );
          });

          if (listElement != null) {
            // Toggle the favorite on
            switch (type) {
              case "color":
                $($(listElement).find("span.color-block")?.[0])?.attr(
                  "data-is-favorite",
                  true
                );
                break;
              case "series":
              default:
                $(listElement).attr("data-is-favorite", true);
                break;
            }
          }
        }
      }
    });
  }
}

/**
 * @description Checks in intervals for an element existence in a document
 * @param {*} queryString the element identifier (string query)
 * @param {*} durationInMS the duration to wait between each try
 * @param {*} retries the maximum amount of tries
 * @returns {HTMLElement | Null}: the resolve of the element querying
 */
const intervalCallback = async (
  durationInMS = 500,
  retries = 10,
  callback = () => {}
) => {
  return new Promise((resolve, reject) => {
    let currentTries = retries;
    const interval = setInterval(() => {
      currentTries -= currentTries;
      if (currentTries < 0) {
        console.error("Elemenet not found.");
        resolve(null);
      }
      const result = callback();
      if (result != null) {
        clearInterval(interval);
        resolve(result);
      }
    }, durationInMS);
  });
};

/**
 * @desctiption Capitalzies the first letter of a string
 */

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * @desctiption Shape finishes/colors
 */
function shapeItemFinishColor(data, selector = "color") {
  return data
    .map((e) => e?.[selector])
    .filter((e) => e?.length > 0)
    .map((e) => {
      if (Array.isArray(e)) {
        return e;
      }
      if (e?.includes(",")) {
        return e?.split(",");
      }
      return [e];
    })
    .flat()
    ?.map((e) => {
      return capitalizeFirstLetter(e?.replace(/\s+/, "").replace(/_/g, " "));
    })
    .sort((e) => (e === "9010" ? -1 : 0));
}

/**
 * @desctiption updates the cart attributes
 */
const addCartAttributes = async (attributes) => {
  try {
    await $.post(window.Shopify.routes.root + "cart/update.js", {
      attributes,
      // note: JSON.stringify(attributes) - Check if this is the intended action
    });
  } catch (ex) {
    console.error(
      `An error occured while updating the cart attributes - ${ex?.message}`
    );
  }
};

Shopify.queue = [];
Shopify.moveAlong = function () {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
    const currentValueElm = $("#current-count");
    const totalCountElm = $("#total-count");

    if (currentValueElm) {
      const currentValue = Number(currentValueElm.text());
      const totalAmount = Number(totalCountElm.text().replace("/", ""));

      // Only increaase the counter visually if the maximum had not been exceeded (this is for hidden items)
      if (currentValue < totalAmount) {
        currentValueElm.text(currentValue + 1);
      }
    }

    // pass the properties into addItem as well
    Shopify.addItem(
      request.variantId,
      request.quantity,
      request.properties,
      Shopify.moveAlong
    );
  }
  // If the queue is empty, we will redirect to the cart page.
  else {
    localStorage.removeItem("bom_csv_items");
    document.location.href = "/cart?fromConfigurator=true";
  }
};
// Create a new Shopify.addItem function that takes the 'properties' parameter
Shopify.addItem = function (id, qty, properties, callback) {
  var params = {
    quantity: qty,
    id: id,
  };
  if (properties != false) {
    params.properties = properties;
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: params,
    success: function () {
      if (typeof callback === "function") {
        callback();
      }
    },
    error: function () {},
  });
};

function push_to_queue(variantID, quantity, properties, callback) {
  Shopify.queue.push({
    variantId: variantID,
    quantity: quantity,
    properties: properties,
  });
  if (typeof callback === "function") {
    callback();
  }
}

/**
 * @description modifies the challenge page with injected styling
 */
function adjustCaptchaStyling() {
  // Find the submit button and adjust its styling
  const submitBtn = document.querySelector(
    'input[type="submit"].shopify-challenge__button.btn'
  );
  submitBtn.classList.add("button");
  submitBtn.classList.add("button--secondary");

  // Add padding to the body
  const body = document.querySelector(".shopify-challenge__container");
  body.style.padding = "15vh 0";

  // add margins to the captcha container
  const captchaContainer = document.querySelector("#g-recaptcha");
  captchaContainer.style.margin = "2vh 0";
}
